import PackageJson from "../../package.json";

export const test = false;
export const name = PackageJson.name;
export const version = PackageJson.version;
export const google_map = true;
export const ga_id = "UA-158635040-1";
export const license = "L2385431";

// Production URL
let _url = process.env.REACT_APP_API_URL_REST;
// let _url = "http://172.172.60.192:8080";
if (window.location.host === "drivers.higaraj.com") {
  // Production Higaraj URL
  _url = "https://api.drivers.higaraj.com";
} else if (window.location.host === "org.higaraj.com") {
  // Production Org URL
  _url = "https://api.org.higaraj.com";
} else if (window.location.host === "t2bon.com") {
  // Production Org URL (for E-Namad)
  _url = "https://api.org.higaraj.com";
} else if (window.location.host === "app.drivers.higaraj.com") {
  // Production Drivers APP URL
  _url = "https://api.app.drivers.higaraj.com";
} else if (window.location.host === "dev.higaraj.com") {
  // Staging URL
  _url = "https://dev.api.higaraj.com";
} else if (window.location.host === "dev.drivers.higaraj.com") {
  // Staging higaraj URL
  _url = "https://dev.api.drivers.higaraj.com";
} else if (window.location.host === "dev.org.higaraj.com") {
  // Staging Org URL
  _url = "https://dev.api.org.higaraj.com";
} else if (window.location.host === "dev.app.drivers.higaraj.com") {
  // Staging Drivers APP URL
  _url = "https://dev.api.app.drivers.higaraj.com";
}
export const BaseURL = _url;

// FOR TEST
// export const BaseURL = "http://192.168.43.173:8000";
// export const BaseURL = "http://127.0.0.1:8000";
// export const BaseURL = 'https://api.t2bon.com';
// export const BaseURL = 'https://snapp.t2bclub.com';
// export const BaseURL = 'https://api.staging.t2bon.com';
// export const BaseURL = 'https://snapp.staging.t2bclub.com';
// export const BaseURL = 'https://f3102dca0d29.ngrok.io';

// -----------------------------------------------------
export const ShowPhone = "021 - 91007969";
export const Phone = "tel:+982191007969";
export const Email = "area@globalindustrialoil.com";
export const PhoneNumber = "+96872221793";
export const WhatsappNumber = "+96871761650";
export const Address = "Alrusayl industrial zone mascut  sultanate of OMAN";
export const site_title = "garajmall";

// export const support_text = `
// <p>
//     To contact with the support team and solve your problems, you can contact us by clicking on the option below.
// </p>
// `;

export const bank_error_text = `
<p>
    متاسفانه پرداخت شما انجام نشد، این اتفاق ممکن است به دلایل مختلفی رخ بدهد،
    در صورتی که از حساب شما مبلغی کسر شده است ، طی 72 ساعت آینده به حساب شما برمیگردد.
</p>
`;

export const bank_done_text = `
<p>
سفارش شما با موفقیت ثبت شد.
برای دریافت خدمات 15 روز فرصت دارید تا به یکی از مراکز ارائه خدمات مراجعه کنید.
</p>
`;

export const bank_cancel_text = `
<p>
Your payment was canceled and your purchase was not completed, you can proceed to payment again by visiting your shopping cart.
</p>
`;

export const terms_text = `
    <h3 className="">نحوه تعویض روغن</h3>
    <p>
    کوپن خریداری شده صرفا جهت تعویض روغن در مراکز معرفی شده می باشد و تحت هیچ شرایطی امکان دریافت گالن روغن از اتوسرویس وجود ندارد.
    </p>
`;

// Dynamic Base Channel
export const BaseChannel = 'default-channel';
// export const BaseChannel = 'promotion-channel';
// export const BaseChannel = "extrapromo-channel";

const channels = {
  "http://localhost:3000": BaseChannel,
  "http://localhost:3001": BaseChannel,
  "http://localhost:3002": BaseChannel,
  "c1e8-213-109-162-76.ngrok-free.app": BaseChannel,
  "172.172.60.107:3001": BaseChannel,
  "172.172.60.107:3000": BaseChannel,
  "172.172.60.114:3001": BaseChannel,
  "http://172.172.60.152:3001": BaseChannel,
  "http://192.168.58.216:3000": BaseChannel,
  "https://garajmall.com": BaseChannel,
  "https://dev.garajmall.com": BaseChannel,
  "http://172.172.60.65:3000": BaseChannel,
  "http://172.172.60.114:3000": BaseChannel,
  "http://172.172.60.116:3001": BaseChannel,
  "http://172.172.60.146:3000": BaseChannel,
  "http://172.172.60.113:3001": BaseChannel,
  "http://172.172.60.208:3000": BaseChannel,
  "http://172.172.60.77:3000": BaseChannel,
};

export const currentChannel = channels[window.location.host] || BaseChannel;

export const getChannelFromUrl = (
  search = window.location.search,
  host = window.location.host,
) => {
  try {
    const params = new URLSearchParams(search);
    const urlChannel = params.get("channel");
    return urlChannel || channels[host] || BaseChannel;
  } catch (e) {
    return channels[host] || BaseChannel;
  }
};

export const getChannel = (search = window.location.search) => {
  try {
    // 1. Check URL first
    const params = new URLSearchParams(search);
    const urlChannel = params.get("channel");
    if (urlChannel) {
      return urlChannel;
    }

    // 2. Check localStorage (Redux state)
    const storedState = localStorage.getItem("Hig");
    if (storedState) {
      const parsedState = JSON.parse(storedState);
      const storedChannel = parsedState?.Login?.channel;
      if (storedChannel) {
        return storedChannel;
      }
    }

    // 3. Fallback (persisted baseline lives in env BaseChannel)
    return BaseChannel;
  } catch (e) {
    return BaseChannel;
  }
};

export const channelDetails = {
  "default-channel": {
    currency: "OMR",
    precision: 3,
    showExtraCategory: true,
    deliveryRules: "gmall-delivery-rules",
    mapCenter: [58.545284, 23.614328],
  },
  "promotion-channel": {
    currency: "OMR",
    precision: 3,
    showExtraCategory: true,
    deliveryRules: "gmall-delivery-rules",
    mapCenter: [58.545284, 23.614328],
  },
  "tasleem-channel": {
    currency: "OMR",
    precision: 3,
    showExtraCategory: true,
    deliveryRules: "gmall-delivery-rules",
    mapCenter: [58.545284, 23.614328],
  },
  canada: {
    currency: "CAD",
    precision: 2,
    showExtraCategory: false,
    deliveryRules: "canada-gmall-delivery-rules",
    mapCenter: [-123.116226, 49.246292],
  },
  "saudi-channel": {
    currency: "SAR",
    precision: 2,
    showExtraCategory: true,
    deliveryRules: "gmall-delivery-rules",
    mapCenter: [46.6753, 24.7136],
  },
};
